export default __webpack_public_path__ + "static/media/Order_Management.cf2fb7e9.svg";